import { SimState, UNLOCKS, XP_FOR_LEVEL } from './types';
import { EnergySystem } from './EnergySystem';
import { EventBus } from './events';

export const ProgressionSystem = {
  addXp(state: SimState, amount: number, bus: EventBus) {
    state.prog.xp += amount;
    while (
      state.prog.level + 1 < XP_FOR_LEVEL.length &&
      state.prog.xp >= XP_FOR_LEVEL[state.prog.level + 1]
    ) {
      state.prog.level++;
      // Level up: expand max energy, refill, unlock relevant tools
      state.res.maxEnergy = 500 + (state.prog.level - 1) * 50;
      EnergySystem.refill(state);
      for (const u of UNLOCKS) {
        if (state.prog.level >= u.level) state.prog.unlocked[u.key] = true;
      }
      bus.emit({ type: 'leveledUp', level: state.prog.level });
    }
  },

  xpForNext(state: SimState): number {
    const lv = state.prog.level;
    return XP_FOR_LEVEL[lv + 1] ?? state.prog.xp;
  },

  xpForCurrent(state: SimState): number {
    return XP_FOR_LEVEL[state.prog.level] ?? 0;
  },
};
